import {
  Av,
  Backdrop,
  Beverage,
  Camera,
  Chair,
  Delivery,
  ElectricalPlug,
  EmptyStar,
  Experiences,
  ExtraSpace,
  Food,
  FullBar,
  Grips,
  Ladder,
  Lamp,
  OfficeSupplies,
  Other,
  Parking,
  PartyAddOns,
  Person,
  UtensilsAndPlates
} from '../../shared-components/icons';

const categoryIcons = {
  av_equipment: Av,
  dropoffs_deliveries: Delivery,
  experiences: Experiences,
  extra_space: ExtraSpace,
  food_drinks: Food,
  furniture: Chair,
  office_supplies: OfficeSupplies,
  other: Other,
  parking: Parking,
  party_addons: PartyAddOns,
  production_equipment: Camera,
  staffing: Person,
  table_settings: UtensilsAndPlates,
  'non-alcoholic_drinks': Beverage,
  alcoholic_drinks: FullBar,
  full_bar_package: FullBar,
  bar_services: FullBar,
  backdrops: Backdrop,
  lighting: Lamp,
  props: EmptyStar,
  grips: Grips,
  power_supplies: ElectricalPlug,
  ladder: Ladder
};

export default categoryIcons;
